module.exports = __webpack_public_path__ + "static/media/ring5.23633868.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/branding/default/audio/ring5.mp3
// module id = 615
// module chunks = 0